<div style="width: auto; overflow: auto">
    <app-common-list-table
        [request]="getRequest"
        [cols]="cols"
        [filtering]="filter"
        [customExportCsv]="env.showTratamientosExportCsv"
        [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform"
        [actionButtonText]="env.canAddTratamientos ? btnAnadir : ''"
        (actionButtonClick)="add()"
        (visualize)="show('info', $event)"
        (edit)="edit($event)"
        (duplicate)="duplicate($event)"
        (remove)="show('delete', $event)">

        <ng-template #header>
            <div *ngIf="showAllTratamientos" class="d-flex justify-content-start align-content-center">
                <p-toggleSwitch
                    [style]="{ marginLeft: '15px', marginRight: '10px' }"
                    [(ngModel)]="showAllTratamientos"
                    (onChange)="changeShowAll(); filterTratamientos()">
                </p-toggleSwitch>

                <p style="color: white; font-size: 1.2em; margin-bottom: 0;">
                    Mostrar todos
                </p>
            </div>
        </ng-template>

        <ng-template #thEnd>
            <th class="rt-col-actions">
                <p class="d-flex justify-content-center mb-0">
                    Acciones
                </p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td class="rt-col-actions">
                <app-action-buttons
                    [showDuplicate]="env.canDuplicateTratamientos"
                    (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)"
                    (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="env.serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>